const LISTENER_LEAK_SAFETY_MS = 180000;
export async function printScreen(options = {}) {
    if (typeof window === "undefined")
        return;
    const { beforePrint, afterPrint } = options;
    await (beforePrint === null || beforePrint === void 0 ? void 0 : beforePrint());
    if (!afterPrint) {
        window.print();
        return;
    }
    let done = false;
    const unreg = [];
    const release = () => {
        for (const u of unreg)
            u();
        unreg.length = 0;
    };
    const finish = () => {
        if (done)
            return;
        done = true;
        release();
        afterPrint();
    };
    const onAfterPrint = () => finish();
    window.addEventListener("afterprint", onAfterPrint, { once: true });
    unreg.push(() => {
        window.removeEventListener("afterprint", onAfterPrint);
    });
    const focusTimer = window.setTimeout(() => {
        if (done)
            return;
        const onFocus = () => finish();
        window.addEventListener("focus", onFocus, { once: true });
        unreg.push(() => {
            window.removeEventListener("focus", onFocus);
        });
    }, 0);
    unreg.push(() => {
        window.clearTimeout(focusTimer);
    });
    const mq = window.matchMedia("print");
    const onMatchChange = () => {
        if (!mq.matches) {
            finish();
        }
    };
    if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", onMatchChange);
        unreg.push(() => {
            mq.removeEventListener("change", onMatchChange);
        });
    }
    else {
        mq.addListener(onMatchChange);
        unreg.push(() => {
            mq.removeListener(onMatchChange);
        });
    }
    const leakTimer = window.setTimeout(() => {
        finish();
    }, LISTENER_LEAK_SAFETY_MS);
    unreg.push(() => {
        window.clearTimeout(leakTimer);
    });
    try {
        window.print();
    }
    catch (e) {
        finish();
        throw e;
    }
}
